import "./Item.css";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import usePricing from "../../../../Utils/hooks/usePricing";

interface ItemPropsInterface {
  stateCheckoutItem: ItemDetailsData;
  isDefaultItem: boolean;
  cbRemoveProduct: (itemId: number) => void;
}

const Item = (props: ItemPropsInterface) => {
  const { getDisplayPrice, formatPrice, cartPricing } = usePricing("cod");

  const baseDisplayPrice = getDisplayPrice(props.stateCheckoutItem.id);

  // Calculate coupon-discounted price proportionally
  const getCouponDiscountedPrice = (): number => {
    if (
      !cartPricing.couponData.isApplied ||
      cartPricing.subtotal.sellingPrice === 0
    ) {
      return baseDisplayPrice;
    }

    // Calculate this item's proportion of the total
    const itemProportion = baseDisplayPrice / cartPricing.subtotal.sellingPrice;

    // Apply proportional coupon discount
    const couponDiscountForItem =
      cartPricing.subtotal.couponDiscount * itemProportion;

    return Math.round(baseDisplayPrice - couponDiscountForItem);
  };

  const displayPrice = getCouponDiscountedPrice();

  const formattedDescription = (
    props.stateCheckoutItem.description || ""
  ).replace(/<br\s*\/?>/gi, "\n\n- ");

  const RoundComponent = () => {
    return (
      <div
        style={{
          height: "10px",
          width: "10px",
          backgroundColor: "rgba(154, 200, 254, 0.3)",
          border: "2px",
          borderColor: "rgba(35, 81, 136, 1)",
          borderRadius: 100,
          marginLeft: "10px",
          marginRight: "10px",
          marginTop: "10px",
        }}
      ></div>
    );
  };

  return (
    <div className="item">
      <div className="wrap">
        <div className="item-title">{props.stateCheckoutItem.name}</div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "60%",
                height: "2px",
                backgroundColor: "rgba(217, 217, 217, 1)",
                alignSelf: "center",
                marginRight: "10px",
              }}
            ></div>
            <div>
              <span
                style={{ textDecoration: "line-through", marginRight: "10px" }}
                className="text-wrapper-3"
              >
                {"₹" + props.stateCheckoutItem.base_price}
              </span>
              <span className="text-wrapper-3">
                {formatPrice(displayPrice)}
              </span>
            </div>
          </div>
          {cartPricing.couponData.isApplied &&
            cartPricing.subtotal.couponDiscount > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginTop: "8px",
                  color: "#10B981",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: '"Cardo", Helvetica',
                }}
              >
                <span>Coupon Discount: </span>
                <span style={{ fontWeight: 600, marginLeft: "5px" }}>
                  -
                  {formatPrice(
                    Math.round(
                      (baseDisplayPrice / cartPricing.subtotal.sellingPrice) *
                        cartPricing.subtotal.couponDiscount
                    )
                  )}
                </span>
              </div>
            )}
        </div>
      </div>

      <div className="item-description">
        <br />
        <div className="item-details-breakdown">
          <RoundComponent />
          <div className="item-details-text" style={{ whiteSpace: "pre-line" }}>
            {formattedDescription}
          </div>
        </div>
        <br />
        <div className="item-details-breakdown">
          <RoundComponent />
          <div className="item-details-text">
            A copy of the NFO Handbook will be delivered to the provided address
            within 7 to 8 business days.
          </div>
        </div>
        <br />
      </div>
    </div>
  );
};

export default Item;
